// extracted by mini-css-extract-plugin
var _1 = "htvHnr3J5zu2KBypeBt7";
var _2 = "xDBaPddRpK64o1xOPJDg";
var _3 = "L9vMyfzxxUzjVHOJ66Wm";
export { _1 as "originDescription", _2 as "originName", _3 as "originProfile" }
